<template>
  <div class="content">
    <h1>TOP SELLING POINTS</h1>
    <ul>
      <li>162 Well-appointed guest rooms</li>
      <li>
        12 Suites and 1 Rooftop Penthouse Suite with private rooftop patio
      </li>
      <li>
        Guest rooms features include:
        <ul>
          <li>Original soaring high ceilings</li>
          <li>Custom rose gold fixtures</li>
          <li>Modern minimalist décor in a soothing color palette</li>
          <li>Premium Sterns & Foster bedding.</li>
          <li>Steamer, in-room safe, and bottled water</li>
        </ul>
      </li>
      <li>
        Enjoy a truly authentic San Diego dining experience at the all-outdoor
        Luca Restaurant serving Chef Justin Vaiciunas’ creative contemporary
        Mediterranean cuisine using California’s finest seasonal ingredients.
      </li>
      <li>
        The bar provides a roaring menu of expertly crafted signature cocktails,
        wine, and local beers.
      </li>
      <li>FAM On Demand and Full Buyouts available.</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Points"
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
h1 {
  font: normal 27px/32px $courier;
  letter-spacing: 0.27px;
  margin-top: 0;
  margin-bottom: 0.5rem;
}

ul {
  padding-inline-start: 1rem;
}

li {
  font: normal 18px/25px $caslon;
  letter-spacing: 0;
  color: $black;
  margin: 1rem 0;
}
</style>
